export default __webpack_public_path__ + "static/media/opensea-icon.5af58a91.svg";